module.exports = __webpack_public_path__ + "img/建筑_building-two-2.a62cb565.svg";